import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';

function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

function VerifyCertificate() {
  const { code } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/certificates/verify_certificate.php`, { params: { code } })
      .then(response => setResult(response.data))
      .catch(() => setResult({ valid: false, message: 'An error occurred while verifying this certificate. Please try again later.' }))
      .finally(() => setLoading(false));
  }, [API_BASE_URL, code]);

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={7}>
          <h2>Certificate Verification</h2>
          {loading && (
            <div className="text-center mt-4">
              <Spinner animation="border" role="status" />
            </div>
          )}
          {!loading && result && result.valid && (
            <Card className="mt-3 border-success">
              <Card.Body>
                <Alert variant="success" className="mb-3">✔ This certificate is genuine.</Alert>
                <dl className="row mb-0">
                  <dt className="col-sm-4">Certificate Type</dt>
                  <dd className="col-sm-8">{result.certificate_type}</dd>
                  <dt className="col-sm-4">Certificate No.</dt>
                  <dd className="col-sm-8">{result.certificate_number}</dd>
                  <dt className="col-sm-4">Issued To</dt>
                  <dd className="col-sm-8">{result.employee_name}</dd>
                  <dt className="col-sm-4">Course</dt>
                  <dd className="col-sm-8">{result.course_title}</dd>
                  <dt className="col-sm-4">Training Date</dt>
                  <dd className="col-sm-8">
                    {result.training_start_date === result.training_end_date
                      ? formatDate(result.training_start_date)
                      : `${formatDate(result.training_start_date)} - ${formatDate(result.training_end_date)}`}
                  </dd>
                  <dt className="col-sm-4">Issued On</dt>
                  <dd className="col-sm-8">{formatDate(result.issued_at)}</dd>
                </dl>
              </Card.Body>
            </Card>
          )}
          {!loading && result && !result.valid && (
            <Alert variant="danger" className="mt-3">✘ {result.message}</Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default VerifyCertificate;
